// Generated by purs version 0.15.15
import * as Data_Either from "../Data.Either/index.js";
import * as Data_Int from "../Data.Int/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Semigroup from "../Data.Semigroup/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Data_Tuple from "../Data.Tuple/index.js";
import * as Data_Unit from "../Data.Unit/index.js";
import * as Foreign from "../Foreign/index.js";
import * as Ouroboros_Models_Brands_DocumentID from "../Ouroboros.Models.Brands.DocumentID/index.js";
import * as Ouroboros_Models_Brands_DocumentName from "../Ouroboros.Models.Brands.DocumentName/index.js";
import * as Ouroboros_Models_Brands_DocumentOutline from "../Ouroboros.Models.Brands.DocumentOutline/index.js";
import * as Ouroboros_Models_Brands_DocumentStyle from "../Ouroboros.Models.Brands.DocumentStyle/index.js";
import * as Ouroboros_Models_Brands_DocumentUploadFile from "../Ouroboros.Models.Brands.DocumentUploadFile/index.js";
import * as Ouroboros_Models_Brands_DocumentUploadFileName from "../Ouroboros.Models.Brands.DocumentUploadFileName/index.js";
import * as Ouroboros_Models_Brands_DocumentWizardType from "../Ouroboros.Models.Brands.DocumentWizardType/index.js";
import * as Ouroboros_Models_Brands_ErrorMessageText from "../Ouroboros.Models.Brands.ErrorMessageText/index.js";
import * as Ouroboros_Models_Brands_HttpStatusCode from "../Ouroboros.Models.Brands.HttpStatusCode/index.js";
import * as Ouroboros_Models_Clients_Lifecycle from "../Ouroboros.Models.Clients.Lifecycle/index.js";
import * as Ouroboros_Models_Core_Ok from "../Ouroboros.Models.Core.Ok/index.js";
import * as Ouroboros_Programs_Controllers_JwtSession from "../Ouroboros.Programs.Controllers.JwtSession/index.js";
import * as Ouroboros_Services_FFI_Env from "../Ouroboros.Services.FFI.Env/index.js";
import * as Ouroboros_Services_FFI_Http from "../Ouroboros.Services.FFI.Http/index.js";
import * as Ouroboros_Services_FFI_PayloadSanitizers from "../Ouroboros.Services.FFI.PayloadSanitizers/index.js";
import * as Ouroboros_Services_FFI_TaskEither from "../Ouroboros.Services.FFI.TaskEither/index.js";
import * as Ouroboros_Services_FFI_Uuid from "../Ouroboros.Services.FFI.Uuid/index.js";
import * as Untagged_TypeCheck from "../Untagged.TypeCheck/index.js";
import * as Untagged_Union from "../Untagged.Union/index.js";
var append = /* #__PURE__ */ Data_Semigroup.append(Data_Semigroup.semigroupArray);
var show = /* #__PURE__ */ Data_Show.show(Data_Show.showInt);
var hasRuntimeTypeRecord = /* #__PURE__ */ Untagged_TypeCheck.hasRuntimeTypeRecord();
var hasRuntimeTypeRecordRLCons = /* #__PURE__ */ Untagged_TypeCheck.hasRuntimeTypeRecordRLCons(/* #__PURE__ */ Untagged_TypeCheck.hasRuntimeTypeRecordRLCons(Untagged_TypeCheck.hasRuntimeTypeRecordRLNil)(Ouroboros_Models_Brands_DocumentWizardType.hasRuntimeTypeDocumentWizardType)({
    reflectSymbol: function () {
        return "type";
    }
}));
var fileNameIsSymbol = {
    reflectSymbol: function () {
        return "fileName";
    }
};
var fileIsSymbol = {
    reflectSymbol: function () {
        return "file";
    }
};
var hasRuntimeTypeRecord1 = /* #__PURE__ */ hasRuntimeTypeRecord(/* #__PURE__ */ Untagged_TypeCheck.hasRuntimeTypeRecordRLCons(/* #__PURE__ */ hasRuntimeTypeRecordRLCons(Ouroboros_Models_Brands_DocumentUploadFileName.hasRuntimeTypeDocumentUploadFileName)(fileNameIsSymbol))(Ouroboros_Models_Brands_DocumentUploadFile.hasRuntimeTypeDocumentUploadFile)(fileIsSymbol));
var hasRuntimeTypeOneOf = /* #__PURE__ */ Untagged_Union.hasRuntimeTypeOneOf(hasRuntimeTypeRecord1)(/* #__PURE__ */ hasRuntimeTypeRecord(/* #__PURE__ */ Untagged_TypeCheck.hasRuntimeTypeRecordRLCons(/* #__PURE__ */ Untagged_TypeCheck.hasRuntimeTypeRecordRLCons(/* #__PURE__ */ Untagged_TypeCheck.hasRuntimeTypeRecordRLCons(/* #__PURE__ */ Untagged_TypeCheck.hasRuntimeTypeRecordRLCons(/* #__PURE__ */ hasRuntimeTypeRecordRLCons(Ouroboros_Models_Brands_DocumentStyle.hasRuntimeTypeDocumentStyle)({
    reflectSymbol: function () {
        return "style";
    }
}))(Ouroboros_Models_Brands_DocumentOutline.hasRuntimeTypeDocumentOutline)({
    reflectSymbol: function () {
        return "outline";
    }
}))(Ouroboros_Models_Brands_DocumentName.hasRuntimeTypeDocumentName)({
    reflectSymbol: function () {
        return "name";
    }
}))(Ouroboros_Models_Brands_DocumentUploadFileName.hasRuntimeTypeDocumentUploadFileName)(fileNameIsSymbol))(Ouroboros_Models_Brands_DocumentUploadFile.hasRuntimeTypeDocumentUploadFile)(fileIsSymbol)));
var getLeft$prime = /* #__PURE__ */ Untagged_Union["getLeft$prime"](hasRuntimeTypeOneOf);
var getRight = /* #__PURE__ */ Untagged_Union.getRight(hasRuntimeTypeOneOf);
var reduce = /* #__PURE__ */ Untagged_Union.reduce(/* #__PURE__ */ Untagged_Union.reduceOneOf(Untagged_Union.reduceA)(hasRuntimeTypeRecord1));
var validationError = function (message) {
    return {
        type: "ValidationError",
        message: Ouroboros_Models_Brands_ErrorMessageText.makeErrorMessageText(message),
        statusCode: Data_Maybe.Nothing.value
    };
};
var unauthorizedError = /* #__PURE__ */ (function () {
    return {
        type: "Unauthorized",
        message: Ouroboros_Models_Brands_ErrorMessageText.makeErrorMessageText("Unauthorized"),
        statusCode: Data_Maybe.Nothing.value
    };
})();
var traceHeaders = function (headers) {
    return Ouroboros_Services_FFI_Http.mkHeaders(append(headers)([ new Data_Tuple.Tuple("X-Trace-ID", Ouroboros_Services_FFI_Uuid.uuidV7(Data_Unit.unit)) ]));
};
var serverError = function (status) {
    return {
        type: "ServerError",
        message: Ouroboros_Models_Brands_ErrorMessageText.makeErrorMessageText("Server responded with an error: " + show(status)),
        statusCode: new Data_Maybe.Just(Ouroboros_Models_Brands_HttpStatusCode.makeHttpStatusCode(Data_Int.toNumber(status)))
    };
};
var parseJson = function (response) {
    return Ouroboros_Services_FFI_TaskEither.tryCatch(function (v) {
        return Ouroboros_Services_FFI_Http.responseJson(response);
    })(function (v) {
        return {
            type: "ValidationError",
            message: Ouroboros_Models_Brands_ErrorMessageText.makeErrorMessageText("Response validation failed"),
            statusCode: Data_Maybe.Nothing.value
        };
    });
};
var networkError = /* #__PURE__ */ (function () {
    return {
        type: "NetworkError",
        message: Ouroboros_Models_Brands_ErrorMessageText.makeErrorMessageText("Failed to connect to the server. Please check your internet connection."),
        statusCode: Data_Maybe.Nothing.value
    };
})();
var handleResponse = function (response) {
    return function (decoder) {
        return function (message) {
            var $55 = Ouroboros_Services_FFI_Http.responseOk(response);
            if ($55) {
                return Ouroboros_Services_FFI_TaskEither.chain(parseJson(response))(function (payload) {
                    var v = decoder(payload);
                    if (v instanceof Data_Either.Left) {
                        return Ouroboros_Services_FFI_TaskEither.left(validationError(message));
                    };
                    if (v instanceof Data_Either.Right) {
                        return Ouroboros_Services_FFI_TaskEither.right(v.value0);
                    };
                    throw new Error("Failed pattern match at Ouroboros.Services.Ouroboros.Lifecycle (line 99, column 9 - line 101, column 44): " + [ v.constructor.name ]);
                });
            };
            return Ouroboros_Services_FFI_TaskEither.left(serverError(Ouroboros_Services_FFI_Http.responseStatus(response)));
        };
    };
};
var fetchWithTrace = function (onUnauthorized) {
    return function (url) {
        return function (init) {
            return Ouroboros_Services_FFI_TaskEither.chain(Ouroboros_Services_FFI_TaskEither.tryCatch(function (v) {
                return Ouroboros_Services_FFI_Http.fetch_(url)(init);
            })(function (v) {
                return networkError;
            }))(function (response) {
                var $59 = Ouroboros_Services_FFI_Http.responseStatus(response) === 401;
                if ($59) {
                    return Ouroboros_Services_FFI_TaskEither.chain(Ouroboros_Services_FFI_TaskEither.fromIO(Ouroboros_Programs_Controllers_JwtSession.actionEffect(onUnauthorized)))(function (v) {
                        return Ouroboros_Services_FFI_TaskEither.left(unauthorizedError);
                    });
                };
                var $60 = !Ouroboros_Services_FFI_Http.responseOk(response);
                if ($60) {
                    return Ouroboros_Services_FFI_TaskEither.left(serverError(Ouroboros_Services_FFI_Http.responseStatus(response)));
                };
                return Ouroboros_Services_FFI_TaskEither.right(response);
            });
        };
    };
};
var buildScratchCreatePayload = function (scratch) {
    return Foreign.unsafeToForeign(scratch);
};
var createDefaultLifecycleClient = function (onUnauthorized) {
    return {
        createDocument: function (request) {
            var v = getLeft$prime(request);
            if (v instanceof Data_Maybe.Just) {
                return Ouroboros_Services_FFI_TaskEither.chain(fetchWithTrace(onUnauthorized)(Ouroboros_Services_FFI_Env.apiUrl + "/v1/apps/writer")(Ouroboros_Services_FFI_Http.requestInitJson("POST")(traceHeaders([ new Data_Tuple.Tuple("Content-Type", "application/json") ]))(buildScratchCreatePayload(v.value0))))(function (response) {
                    return handleResponse(response)(Ouroboros_Models_Clients_Lifecycle.decodeCreateDocumentResponse)("Invalid create document payload");
                });
            };
            if (v instanceof Data_Maybe.Nothing) {
                var v1 = getRight(request);
                if (v1 instanceof Data_Maybe.Nothing) {
                    return Ouroboros_Services_FFI_TaskEither.left(validationError("Invalid create document request"));
                };
                if (v1 instanceof Data_Maybe.Just) {
                    return reduce(new Data_Tuple.Tuple(function (edit) {
                        var formData0 = Ouroboros_Services_FFI_Http.newFormData(Data_Unit.unit);
                        var fileValue = Ouroboros_Models_Brands_DocumentUploadFile.unwrap(edit.file);
                        var fileNameValue = Ouroboros_Models_Brands_DocumentUploadFileName.unwrap(edit.fileName);
                        var formData1 = Ouroboros_Services_FFI_Http.appendFormData(formData0)("file")(Foreign.unsafeToForeign(fileValue))(new Data_Maybe.Just(fileNameValue));
                        var requestInit = Ouroboros_Services_FFI_Http.requestInitFormData("POST")(traceHeaders([  ]))(formData1);
                        return Ouroboros_Services_FFI_TaskEither.chain(fetchWithTrace(onUnauthorized)(Ouroboros_Services_FFI_Env.apiUrl + "/v1/apps/writer/upload")(requestInit))(function (response) {
                            return handleResponse(response)(Ouroboros_Models_Clients_Lifecycle.decodeCreateDocumentResponse)("Invalid create document payload");
                        });
                    }, function (example) {
                        var styleValue = Ouroboros_Models_Brands_DocumentStyle.unwrap(example.style);
                        var outlineValue = Ouroboros_Models_Brands_DocumentOutline.unwrap(example.outline);
                        var nameValue = Ouroboros_Models_Brands_DocumentName.unwrap(example.name);
                        var formData0 = Ouroboros_Services_FFI_Http.newFormData(Data_Unit.unit);
                        var fileValue = Ouroboros_Models_Brands_DocumentUploadFile.unwrap(example.file);
                        var fileNameValue = Ouroboros_Models_Brands_DocumentUploadFileName.unwrap(example.fileName);
                        var formData1 = Ouroboros_Services_FFI_Http.appendFormData(formData0)("file")(Foreign.unsafeToForeign(fileValue))(new Data_Maybe.Just(fileNameValue));
                        var formData2 = Ouroboros_Services_FFI_Http.appendFormData(formData1)("outline")(Foreign.unsafeToForeign(outlineValue))(Data_Maybe.Nothing.value);
                        var formData3 = Ouroboros_Services_FFI_Http.appendFormData(formData2)("style")(Foreign.unsafeToForeign(styleValue))(Data_Maybe.Nothing.value);
                        var formData4 = Ouroboros_Services_FFI_Http.appendFormData(formData3)("name")(Foreign.unsafeToForeign(nameValue))(Data_Maybe.Nothing.value);
                        var requestInit = Ouroboros_Services_FFI_Http.requestInitFormData("POST")(traceHeaders([  ]))(formData4);
                        return Ouroboros_Services_FFI_TaskEither.chain(fetchWithTrace(onUnauthorized)(Ouroboros_Services_FFI_Env.apiUrl + "/v1/apps/writer/upload/example-document")(requestInit))(function (response) {
                            return handleResponse(response)(Ouroboros_Models_Clients_Lifecycle.decodeCreateDocumentResponse)("Invalid create document payload");
                        });
                    }))(v1.value0);
                };
                throw new Error("Failed pattern match at Ouroboros.Services.Ouroboros.Lifecycle (line 125, column 11 - line 165, column 30): " + [ v1.constructor.name ]);
            };
            throw new Error("Failed pattern match at Ouroboros.Services.Ouroboros.Lifecycle (line 113, column 7 - line 165, column 30): " + [ v.constructor.name ]);
        },
        uploadSourceDocument: function (request) {
            return Ouroboros_Services_FFI_TaskEither.chain(fetchWithTrace(onUnauthorized)(Ouroboros_Services_FFI_Env.apiUrl + "/v1/apps/writer/source-document")(Ouroboros_Services_FFI_Http.requestInitJson("POST")(traceHeaders([ new Data_Tuple.Tuple("Content-Type", "application/json") ]))(Foreign.unsafeToForeign(request))))(function (response) {
                return handleResponse(response)(Ouroboros_Models_Clients_Lifecycle.decodeUploadSourceDocumentResponse)("Invalid upload source document payload");
            });
        },
        fetchOutline: function (documentId) {
            return Ouroboros_Services_FFI_TaskEither.chain(fetchWithTrace(onUnauthorized)(Ouroboros_Services_FFI_Env.apiUrl + "/v1/apps/writer/document/outline")(Ouroboros_Services_FFI_Http.requestInitNoBody("GET")(traceHeaders([ new Data_Tuple.Tuple("Content-Type", "application/json"), new Data_Tuple.Tuple("X-Document-ID", Ouroboros_Models_Brands_DocumentID.unwrap(documentId)) ]))))(function (response) {
                return handleResponse(response)(Ouroboros_Models_Clients_Lifecycle.decodeOutlineResponse)("Invalid outline payload");
            });
        },
        fetchDocument: function (documentId) {
            return Ouroboros_Services_FFI_TaskEither.chain(fetchWithTrace(onUnauthorized)(Ouroboros_Services_FFI_Env.apiUrl + "/v1/apps/writer/document")(Ouroboros_Services_FFI_Http.requestInitNoBody("GET")(traceHeaders([ new Data_Tuple.Tuple("Content-Type", "application/json"), new Data_Tuple.Tuple("X-Document-ID", Ouroboros_Models_Brands_DocumentID.unwrap(documentId)) ]))))(function (response) {
                return handleResponse(response)(function ($67) {
                    return Ouroboros_Models_Clients_Lifecycle.decodeDocumentFetchResponse(Ouroboros_Services_FFI_PayloadSanitizers.sanitizeLifecycleDocumentPayload($67));
                })("Invalid document payload");
            });
        },
        listAvailableDocuments: Ouroboros_Services_FFI_TaskEither.chain(fetchWithTrace(onUnauthorized)(Ouroboros_Services_FFI_Env.apiUrl + "/v1/apps/writer")(Ouroboros_Services_FFI_Http.requestInitNoBody("GET")(traceHeaders([  ]))))(function (response) {
            return handleResponse(response)(Ouroboros_Models_Clients_Lifecycle.decodeListAvailableDocumentsResponse)("Invalid available documents payload");
        }),
        downloadDocumentAsBlob: function (documentId) {
            return Ouroboros_Services_FFI_TaskEither.chain(fetchWithTrace(onUnauthorized)(Ouroboros_Services_FFI_Env.apiUrl + "/v1/apps/writer/document/export/word")(Ouroboros_Services_FFI_Http.requestInitNoBody("GET")(traceHeaders([ new Data_Tuple.Tuple("X-Document-ID", Ouroboros_Models_Brands_DocumentID.unwrap(documentId)) ]))))(function (response) {
                var $65 = Ouroboros_Services_FFI_Http.responseOk(response);
                if ($65) {
                    return Ouroboros_Services_FFI_TaskEither.tryCatch(function (v) {
                        return Ouroboros_Services_FFI_Http.responseBlob(response);
                    })(function (v) {
                        return validationError("Failed to parse the document download response.");
                    });
                };
                return Ouroboros_Services_FFI_TaskEither.left(serverError(Ouroboros_Services_FFI_Http.responseStatus(response)));
            });
        },
        deleteDocument: function (documentId) {
            return Ouroboros_Services_FFI_TaskEither.chain(fetchWithTrace(onUnauthorized)(Ouroboros_Services_FFI_Env.apiUrl + ("/v1/apps/writer/" + Ouroboros_Models_Brands_DocumentID.unwrap(documentId)))(Ouroboros_Services_FFI_Http.requestInitNoBody("DELETE")(traceHeaders([  ]))))(function (response) {
                var $66 = Ouroboros_Services_FFI_Http.responseOk(response);
                if ($66) {
                    return Ouroboros_Services_FFI_TaskEither.right(Ouroboros_Models_Core_Ok.ok);
                };
                return Ouroboros_Services_FFI_TaskEither.left(serverError(Ouroboros_Services_FFI_Http.responseStatus(response)));
            });
        }
    };
};
export {
    createDefaultLifecycleClient
};
//# sourceMappingURL=index.js.map
